export default __webpack_public_path__ + "static/media/Shadow's Straps of the Hidden Palace.8fc097f9.jpg";